module.exports = __webpack_public_path__ + "static/media/icon-doc.353db59a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-doc.svg
// module id = 519
// module chunks = 0